import { PAGE_PATHS } from '@/app/constants/pages';
import PeriodInitializer from '@/components/periodDetails/PeriodInitializer';
import { PeriodProvider } from '@/context/PeriodContext';
import Admin from '@/pages/admin';
import Projects from '@/pages/projects';
import Redirect from '@/pages/redirecting';
import PERMISSION_ROLES, { PAGE_NAMES } from '@constants/roles';
import RequireAuth from '@features/auth/RequireAuth';
import RequireLogin from '@features/auth/RequireLogin';
import Layout from '@pages/layout';
import Login from '@pages/login';

import YearInitializer from '@/components/periodDetails/YearInitializer';
import { BranchProvider } from '@/context/BranchsContext';
import { FinancialGroupProvider } from '@/context/FinancialGroup';
import { FinancialSubGroupProvider } from '@/context/FinancialSubGroup';
import { ProjectProvider } from '@/context/ProjectSearchContext';
import { YearProvider } from '@/context/yearsContext';
import CostTrackingBreadcrumb from '@/pages/Breadcrumb/CostTrackingBreadcrumb';
import ProjectsBreadcrumb from '@/pages/Breadcrumb/ProjectsBreadcrumb';
import CostTrackingDetails from '@/pages/costTrackingDetails';
import Imports from '@/pages/imports';
import CostTrackingLayout from '@/pages/layout/CostTrackingLayout';
import PeriodDetailsPage from '@/pages/periodDetails';
import ProjectsDetails from '@/pages/projectsDetails';
import { Route, Routes } from 'react-router-dom';

function AppRoute() {
  return (
    <PeriodProvider>
      <YearProvider>
        <BranchProvider>
          <FinancialGroupProvider>
            <FinancialSubGroupProvider>
              <ProjectProvider>
                <Routes>
                  <Route path="/login" element={<Login />} />
                  <Route element={<RequireLogin />}>
                    <Route element={<YearInitializer />}>
                      <Route element={<PeriodInitializer />}>
                        <Route element={<Layout />}>
                          {/* public routes */}
                          <Route path="/" element={<Redirect />} />
                          <Route path={PAGE_PATHS.IMPORTS} element={<Imports />} />
                          <Route path={PAGE_PATHS.PROJECTS} element={<Projects />} />
                          <Route element={<PeriodDetailsPage />}>
                            <Route element={<ProjectsBreadcrumb />}>
                              <Route path="/projects/:code" element={<ProjectsDetails />} />
                              <Route path="/projects/:code/:category" element={<ProjectsDetails />} />
                            </Route>
                          </Route>
                          <Route element={<CostTrackingLayout />}>
                            <Route element={<CostTrackingBreadcrumb />}>
                              <Route path="/projects/:code/cost-tracking" element={<CostTrackingDetails />} />
                              <Route path="/projects/:code/cost-tracking/:category" element={<CostTrackingDetails />} />
                            </Route>
                          </Route>
                          {/* protected routes for ADMIN */}
                          <Route element={<RequireAuth roles={PERMISSION_ROLES[PAGE_NAMES.ADMIN]} />}>
                            <Route path={PAGE_PATHS.ADMIN} element={<Admin />} />
                          </Route>
                        </Route>
                      </Route>
                    </Route>
                  </Route>
                </Routes>
              </ProjectProvider>
            </FinancialSubGroupProvider>
          </FinancialGroupProvider>
        </BranchProvider>
      </YearProvider>
    </PeriodProvider>
  );
}

export default AppRoute;
